<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xii"></a>
<div class="image_container">
<img alt="images" src="images/f0012-01.jpg"/>
<p class="caption">Stanley Goodall’s portrait was painted by James Barraclough and presented to him in March 1938. For many years it was on display at the Royal Institution of Naval Architects offices in London but is now at University College, London.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Front01.vue?564e7fb0